import { fileshubLoadingIndicatorText } from './LoadingIndicator.locstring.json';
import loc from 'owa-localize';
import {
    getRecentFilesViewState,
    getSpListViewStateData,
    isSpLoading,
    isSpAbsent,
    RecentFilesViewState,
    SharePointListState,
} from 'owa-group-files-hub-store';

import { SpinnerSize, Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { observer } from 'mobx-react';
import * as React from 'react';

const styles = require('./FilesHub.scss');

@observer
export class LoadingIndicator extends React.Component<{}, {}> {
    render(): JSX.Element {
        const recentState = getRecentFilesViewState.get();
        const spState = getSpListViewStateData.get();

        if (this.stillLoading(recentState, spState)) {
            return (
                <Spinner
                    className={styles.loadingIndicator}
                    label={loc(fileshubLoadingIndicatorText)}
                    size={SpinnerSize.large}
                />
            );
        }

        return null;
    }

    private stillLoading(recentState: RecentFilesViewState, spState: SharePointListState): boolean {
        if (!recentState || recentState.isLoading || !spState) {
            return true;
        }

        if (isSpAbsent(spState)) {
            return false;
        }

        if (isSpLoading(spState)) {
            return true;
        }

        return false;
    }
}
